'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * Factory function to create a local context for a domain that
 * exposes Slots passed from the opco to its components.
 *
 * This hook removes some boilerplate code required and also
 * restricts the type of "slots" passed to the provider
 *
 * @usage
 * -- Create a local SlotsContext --
 * type SampleSlots = { Foo: React.ComponentType<{ bar: string }> }
 * const [SampleSlotsProvider, useSampleSlots] = createSlotsContext<SampleSlots>({
 *   displayName: 'SampleSlotsContext'
 * })
 * export { SampleSlotsProvider, useSampleSlot }
 *
 * -- In Opco --
 * const slots = { Foo: ({ bar }) => <div>Hello {bar}!</div>}
 *
 * <SampleSlotsProvider slots={slots}>...</SampleSlotsProvider>
 *
 * -- In Core component --
 * const { Slots } = useSampleSlots()
 *
 * <div>
 *   {Slots.Foo ? <Slots.Foo bar="something" /> : null}
 * </div>
 */ function createSlotsContext({ displayName  }) {
    const SlotsContext = /*#__PURE__*/ React__namespace.createContext({});
    SlotsContext.displayName = displayName;
    const SlotsProvider = ({ slots , children  })=>{
        return /*#__PURE__*/ React__namespace.createElement(SlotsContext.Provider, {
            value: slots
        }, children);
    };
    const useSlots = ()=>{
        const context = React__namespace.useContext(SlotsContext);
        if (!context) {
            // Don't throw here as SlotProviders are optional for opcos
            console.error(`No ${displayName} found. You might need to wrap your component in the Provider.`);
            return {
                Slots: {}
            };
        }
        return {
            Slots: context
        };
    };
    return [
        SlotsProvider,
        useSlots
    ];
}

exports.createSlotsContext = createSlotsContext;
//# sourceMappingURL=create-context.js.map
